<template>
  <a :href="accountReviewUrl" target="_blank" rel="noopener noreferrer" class="s-reviewLink">
    <v-icon size="small">far fa-gift</v-icon>
    {{ $t("account.login.rateUs") }}
  </a>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useI18n } from "vue-i18n"

import { ACCOUNT_REVIEW_URL_BY_LANGUAGE } from "@/modules/account/constants"

const { locale } = useI18n<any, keyof typeof ACCOUNT_REVIEW_URL_BY_LANGUAGE>()

const accountReviewUrl = computed(() => ACCOUNT_REVIEW_URL_BY_LANGUAGE[locale.value])
</script>

<style lang="scss" scoped>
.s-reviewLink {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  line-height: 20px;
  color: inherit;
  text-decoration: none;
}

.s-reviewLink:hover {
  text-decoration: underline;
}
</style>
